<template>
  <div>
    <h3>批次名称：{{ creatData.bill.name }}</h3>
    <!-- <div @click='go() '>返回</div> -->
    <div class="searchBox">
      <ul>
        <li>
          创建人：<span>{{ creatData.saleUser.name }}</span>
        </li>
        <li>
          订购清单：<span>{{
            creatData.product ? creatData.product.name : "无"
          }}</span>
        </li>
        <li>
          财务状态：<span class="yellow">{{
            billingState[creatData.bill.billingState]
          }}</span>
        </li>
        <li>
          创建时间：<span>{{ setTime(creatData.bill.createAt) }}</span>
        </li>
        <li>
          订单号：<span>{{ creatData.bill.billingNo }}</span>
        </li>
        <li>
          购买数量：<span>{{ allpage }}个</span>
        </li>
        <li v-if="creatData.bill.orderType != 2">
          备注：<span>{{ creatData.bill.remark || "无" }}</span>
        </li>
        <!-- <span v-if="$route.query.type != 'type'"> -->
          <li v-if="tableData[0] && tableData[0].orderType != 2">
            下载：<span class="blue" @click="downPdf">凭证下载</span>
          </li>
          <li v-else>
            <span v-if="gridData != null">
              下载：<span
              v-if="gridData.length != 0 "
              class="blue"
              @click="tdDownPdf"
              >凭证下载</span
            ><span v-else style="color: #cccccc">凭证下载</span>
            </span>
          </li>
        <!-- </span> -->
      </ul>
    </div>
    <div class="searchBox" v-if="false">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="快捷搜索">
          <el-input
            style="width: 400px"
            v-model="formInline.text"
            type="text"
            placeholder="手机号 / 证件号"
          ></el-input>
        </el-form-item>
        <el-button class="text2" type="primary" @click="seachBox"
          >搜索</el-button
        >
      </el-form>
    </div>
    <div class="zsh" v-if="$route.query.type == 'type'">
      <div v-if="creatData.details[0].extra">
        <div class="table">
          <el-table
            :data="tableData"
            row-key="id"
            style="width: 100%; font-size: 14px"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table
                  :data="props.row.parentDetail"
                  v-if="
                    props.row.parentDetail[0] != undefined &&
                    props.row.parentDetail[0] != null
                  "
                  stripestyle="width: 100%"
                >
                  <el-table-column
                    width="180"
                    prop="name"
                    show-overflow-tooltip
                    label="姓名"
                  ></el-table-column>
                  <el-table-column show-overflow-tooltip label="手机号">
                    <template slot-scope="scope">
                      <!-- {{props.row.parentDetail[0]}} -->
                      <span>{{
                        props.row.parentDetail[0].mobileno || "--"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="160"
                    show-overflow-tooltip
                    label="证件号码"
                  >
                    <template slot-scope="scope">
                      <span>{{
                        props.row.parentDetail[0].nationalId || "待激活"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="保障开始日期">
                    <template slot-scope="scope">
                      <span>{{
                        props.row.parentDetail[0].validFrom
                          ? setTime(props.row.parentDetail[0].validFrom)
                          : "--"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="保障结束日期">
                    <template slot-scope="scope">
                      <span>{{
                        props.row.parentDetail[0].validUtil
                          ? setTime(props.row.parentDetail[0].validUtil - 1000)
                          : "--"
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="保障卡号">
                    <template slot-scope="scope">
                      <el-tooltip
                        effect="dark"
                        content="点击复制激活卡号"
                        placement="top"
                      >
                        <a
                          :data-clipboard-text="props.row.parentDetail[0].code"
                          class="copeA icon-copy"
                          >{{ props.row.parentDetail[0].code }}</a
                        >
                      </el-tooltip>
                    </template>
                  </el-table-column>
                  <el-table-column show-overflow-tooltip label="保单号">
                    <template slot-scope="scope">
                      <span v-if="!props.row.parentDetail[0].policyNo">--</span>
                      <a
                        v-else
                        :href="props.row.parentDetail[0].policyUrl"
                        target="_blank"
                        class="blue"
                        >{{ props.row.parentDetail[0].policyNo }}</a
                      >
                    </template>
                  </el-table-column>

                  <el-table-column label="激活地址">
                    <template slot-sope="scope">
                      <a
                        v-if="props.row.parentDetail[0].validFrom == undefined"
                        :data-clipboard-text="props.row.parentDetail[0].copy"
                        class="blue icon-copy"
                        >复制激活地址</a
                      >
                      <span v-else>已激活</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <a
                        v-if="props.row.parentDetail[0].serviceCredential"
                        :href="props.row.parentDetail[0].serviceCredential"
                        target="_blank"
                        class="blue"
                        >查看凭证</a
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="用户姓名" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.name || "待激活" }}</span>
              </template>
            </el-table-column>

            <el-table-column label="手机号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.mobileno || "--" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              label="证件号码"
              align="center"
              width="170"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.nationalId || "待激活" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              label="保障开始日期"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.validFrom ? setTime(scope.row.validFrom) : "--"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              label="保障结束日期"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  >{{
                    scope.row.validUtil
                      ? setTime(scope.row.validUtil - 1000)
                      : "--"
                  }}
                </span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              prop="code"
              label="保障卡号"
              align="center"
            >
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  content="点击复制激活卡号"
                  placement="top"
                >
                  <a
                    :data-clipboard-text="scope.row.code"
                    class="copeA icon-copy"
                    >{{ scope.row.code }}</a
                  >
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              prop="policyNo"
              label="保单号"
              align="center"
              width="190px"
            >
              <template slot-scope="scope">
                <span v-if="!scope.row.policyNo">--</span>
                <a
                  v-else
                  :href="scope.row.policyUrl"
                  target="_blank"
                  class="blue"
                  >{{ scope.row.policyNo }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              label="备注"
              v-if="creatData.product.productGroup == 'G197'"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.resident }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="creatData.product.productGroup != 'G67'"
              label="激活地址"
            >
              <template slot-scope="scope">
                <a
                  v-if="scope.row.validFrom == undefined"
                  :data-clipboard-text="scope.row.copy"
                  class="blue icon-copy"
                  >复制激活地址</a
                >
                <span v-else>已激活</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="
                creatData.product.productGroup == 'G67' ||
                creatData.product.productGroup == 'G70' ||
                creatData.product.productGroup == 'G75' ||
                creatData.product.productGroup == 'G76'
              "
              label="地址"
            >
              <template slot-scope="scope">
                <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
                <span>{{ scope.row.resident }}</span>
              </template>
            </el-table-column>

            <el-table-column
              v-if="creatData.product.productGroup == 'G74'"
              label="航班/车次号"
            >
              <template slot-scope="scope">
                <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
                <span>{{ scope.row.resident }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="divisionDay == 1 || divisionDay == 3"
              label="天数"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.continueDay }}日</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="300">
              <template slot-scope="scope">
                <span class="yellow">{{
                  billingState[scope.row.billingState]
                }}</span>
                <el-tooltip effect="dark" content="请先激活" placement="top">
                  <span
                    v-if="!scope.row.validFrom"
                    style="color: #ccc; cursor: pointer"
                    >查看凭证</span
                  >
                </el-tooltip>
                <template v-if="scope.row.validFrom">
                  <el-button
                    v-if="!scope.row.serviceCredential"
                    type="text"
                    disabled
                    ><i class="el-icon-loading"></i>正在生成凭证</el-button
                  >
                  <a
                    v-if="scope.row.serviceCredential"
                    :href="scope.row.serviceCredential"
                    target="_blank"
                    class="blue"
                    >查看凭证</a
                  >
                </template>
                <!-- <template >
							<el-button  type='text' >下载发票</el-button>
						</template> -->

                <template>
                  <el-button
                    v-if="
                      scope.row.billingState == 0 ||
                      scope.row.billingState == 4 ||
                      (scope.row.validFrom &&
                        scope.row.validFrom < scope.row.nowTime)
                    "
                    type="text"
                    disabled
                    >退单</el-button
                  >
                  <!-- <el-button v-else-if='scope.row.validFrom != undefined && scope.row.parentId != null' type='text' disabled>退单</el-button> -->
                  <el-button
                    v-else
                    type="text"
                    @click="
                      centerDialogVisible = true;
                      exitData = scope.row;
                    "
                    >退单</el-button
                  >
                  <!-- <el-button  type='text' @click='centerDialogVisible=true;exitData=scope.row'>退单</el-button> -->
                  <!-- <span v-if="scope.row.product.includeInsurance == 0">
                <el-button v-if="scope.row.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
                </template>

                <!-- <el-button v-if="scope.row.validFrom != undefined&&">开发票</el-button>
						<el-button v-else type='text'>开发票</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div><b>其他信息</b></div>
        <div>
          所属集体二级企业:{{
            JSON.parse(creatData.details[0].extra).companyName
          }}
        </div>
        <div>
          投保人:{{ JSON.parse(creatData.details[0].extra).insureName }}
        </div>
        <div>
          项目名称:{{ JSON.parse(creatData.details[0].extra).projectName }}
        </div>
        <div>
          职业:{{ JSON.parse(creatData.details[0].extra).occupationName }}
        </div>
        <div>外派国家:{{ creatData.details[0].resident }}</div>
        <div>保险起期:{{ setTime(creatData.details[0].validFrom) }}</div>
        <div>
          保险月份:{{ JSON.parse(creatData.details[0].extra).insredMonth }}
        </div>
      </div>
    </div>
    <div v-else>
      <div class="table">
        <el-table
          :data="tableData"
          row-key="id"
          style="width: 100%"
          height="calc(100vh - 350px)"
        >
          <!-- <el-table-column label="用户姓名" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.name || '待激活'}}</span>
					</template>
				</el-table-column>
			
				<el-table-column label="手机号" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.mobileno || '--'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="证件号码" align='center' width="170">
					<template slot-scope="scope">
						<span>{{scope.row.detail.nationalId || '待激活'}}</span>
					</template>
				</el-table-column>
				<el-table-column label="保障开始日期" align='center'>
					<template slot-scope="scope">
						<span>{{scope.row.detail.validFrom? setTime(scope.row.detail.validFrom) :'--'}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="code" label="保障卡号" align='center'>
					<template slot-scope="scope">
						<el-tooltip effect="dark" content="点击复制激活卡号" placement="top">
							<a :data-clipboard-text="scope.row.detail.code" class="copeA icon-copy">{{scope.row.detail.code}}</a>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column prop="policyNo" label="保单号" align='center' width="190px">
					<template slot-scope="scope">
						<span v-if="!scope.row.detail.policyNo">--</span>
						<a v-else :href="scope.row.detail.policyUrl" target="_blank" class="blue">{{scope.row.detail.policyNo}}</a>
					</template>
				</el-table-column>
				<el-table-column label="激活地址">
					<template slot-scope="scope">
						<a v-if="scope.row.detail.validFrom == undefined" :data-clipboard-text="scope.row.detail.copy" class="blue icon-copy">复制激活地址</a>
						<span v-else>已激活</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align='center' width="300">
					<template slot-scope="scope">
						<span class="yellow">{{billingState[scope.row.detail.billingState]}}</span>
						<el-tooltip effect="dark" content="请先激活" placement="top">
							<span v-if="!scope.row.detail.validFrom" style="color: #ccc;cursor: pointer;">查看凭证</span>
						</el-tooltip>
						<template v-if="scope.row.detail.validFrom">
							<el-button v-if="!scope.row.detail.serviceCredential"  type='text' disabled><i class="el-icon-loading"></i>正在生成凭证</el-button>
							<a v-if="scope.row.detail.serviceCredential" :href="scope.row.detail.serviceCredential" target="_blank" class="blue">查看凭证</a>
						</template>
            <template>
              <el-button v-if='scope.row.detail.billingState == 0 || scope.row.detail.billingState == 4 || (scope.row.detail.validFrom && scope.row.detail.validFrom < scope.row.detail.nowTime)' type='text' disabled>退单</el-button>
              <el-button v-else type='text' @click='centerDialogVisible=true;exitData=scope.row'>退单</el-button>
               <span v-if="scope.row.product.includeInsurance == 0">
                <el-button v-if="scope.row.detail.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                :data="props.row.parentDetail"
                v-if="props.row.parentDetail[0] != undefined"
                stripestyle="width: 100%"
              >
                <el-table-column
                  width="180"
                  prop="name"
                  show-overflow-tooltip
                  label="姓名"
                ></el-table-column>
                <el-table-column show-overflow-tooltip label="手机号">
                  <template slot-scope="scope">
                    <!-- {{props.row.parentDetail[0]}} -->
                    <span>{{
                      props.row.parentDetail[0].mobileno || "--"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  width="160"
                  show-overflow-tooltip
                  label="证件号码"
                >
                  <template slot-scope="scope">
                    <span>{{
                      props.row.parentDetail[0].nationalId || "待激活"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="保障开始日期">
                  <template slot-scope="scope">
                    <span>{{
                      props.row.parentDetail[0].validFrom
                        ? setTime(props.row.parentDetail[0].validFrom)
                        : "--"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="保障结束日期">
                  <template slot-scope="scope">
                    <span>{{
                      props.row.parentDetail[0].validUtil
                        ? setTime(props.row.parentDetail[0].validUtil - 1000)
                        : "--"
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="保障卡号">
                  <template slot-scope="scope">
                    <el-tooltip
                      effect="dark"
                      content="点击复制激活卡号"
                      placement="top"
                    >
                      <a
                        :data-clipboard-text="props.row.parentDetail[0].code"
                        class="copeA icon-copy"
                        >{{ props.row.parentDetail[0].code }}</a
                      >
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="保单号">
                  <template slot-scope="scope">
                    <span v-if="!props.row.parentDetail[0].policyNo">--</span>
                    <a
                      v-else
                      :href="props.row.parentDetail[0].policyUrl"
                      target="_blank"
                      class="blue"
                      >{{ props.row.parentDetail[0].policyNo }}</a
                    >
                  </template>
                </el-table-column>

                <el-table-column label="激活地址">
                  <template slot-sope="scope">
                    <a
                      v-if="props.row.parentDetail[0].validFrom == undefined"
                      :data-clipboard-text="props.row.parentDetail[0].copy"
                      class="blue icon-copy"
                      >复制激活地址</a
                    >
                    <span v-else>已激活</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <a
                      v-if="props.row.parentDetail[0].serviceCredential"
                      :href="props.row.parentDetail[0].serviceCredential"
                      target="_blank"
                      class="blue"
                      >查看凭证</a
                    >
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="用户姓名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name || "待激活" }}</span>
            </template>
          </el-table-column>

          <el-table-column label="手机号" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.mobileno || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            label="证件号码"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.nationalId || "待激活" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            label="保障开始日期"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.validFrom ? setTime(scope.row.validFrom) : "--"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            label="保障结束日期"
            align="center"
          >
            <template slot-scope="scope">
              <span
                >{{
                  scope.row.validUtil
                    ? setTime(scope.row.validUtil - 1000)
                    : "--"
                }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            prop="code"
            label="保障卡号"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip
                effect="dark"
                content="点击复制激活卡号"
                placement="top"
              >
                <a
                  :data-clipboard-text="scope.row.code"
                  class="copeA icon-copy"
                  >{{ scope.row.code }}</a
                >
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            prop="policyNo"
            label="保单号"
            align="center"
            width="190px"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.policyNo">--</span>
              <a
                v-else
                :href="scope.row.policyUrl"
                target="_blank"
                class="blue"
                >{{ scope.row.policyNo }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            v-if="creatData.product.productGroup == 'G197'"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.resident }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="creatData.product.productGroup != 'G67'"
            label="激活地址"
          >
            <template slot-scope="scope">
              <a
                v-if="scope.row.validFrom == undefined"
                :data-clipboard-text="scope.row.copy"
                class="blue icon-copy"
                >复制激活地址</a
              >
              <span v-else>已激活</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="
              creatData.product.productGroup == 'G67' ||
              creatData.product.productGroup == 'G70' ||
              creatData.product.productGroup == 'G75' ||
              creatData.product.productGroup == 'G76'
            "
            label="地址"
          >
            <template slot-scope="scope">
              <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
              <span>{{ scope.row.resident }}</span>
            </template>
          </el-table-column>

          <el-table-column
            v-if="creatData.product.productGroup == 'G74'"
            label="航班/车次号"
          >
            <template slot-scope="scope">
              <!-- <a v-if="scope.row.validFrom == undefined" :data-clipboard-text="scope.row.copy" class="blue icon-copy">复制激活地址</a> -->
              <span>{{ scope.row.resident }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="divisionDay == 1 || divisionDay == 3"
            label="天数"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.continueDay }}日</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <span class="yellow">{{
                billingState[scope.row.billingState]
              }}</span>
              <el-tooltip effect="dark" content="请先激活" placement="top">
                <span
                  v-if="!scope.row.validFrom"
                  style="color: #ccc; cursor: pointer"
                  >查看凭证</span
                >
              </el-tooltip>
              <template v-if="scope.row.validFrom">
                <el-button
                  v-if="!scope.row.serviceCredential"
                  type="text"
                  disabled
                  ><i class="el-icon-loading"></i>正在生成凭证</el-button
                >
                <a
                  v-if="scope.row.serviceCredential"
                  :href="scope.row.serviceCredential"
                  target="_blank"
                  class="blue"
                  >查看凭证</a
                >
              </template>
              <!-- <template >
							<el-button  type='text' >下载发票</el-button>
						</template> -->

              <template>
                <el-button
                  v-if="
                    scope.row.billingState == 0 ||
                    scope.row.billingState == 4 ||
                    (scope.row.validFrom &&
                      scope.row.validFrom < scope.row.nowTime)
                  "
                  type="text"
                  disabled>退单</el-button
                >
                <!-- <el-button v-else-if='scope.row.validFrom != undefined && scope.row.parentId != null' type='text' disabled>退单</el-button> -->
                <el-button
                  v-else
                  type="text"
                  @click="
                    centerDialogVisible = true;
                    exitData = scope.row;
                  "
                  >退单</el-button
                >
                <!-- <el-button  type='text' @click='centerDialogVisible=true;exitData=scope.row'>退单</el-button> -->
                <!-- <span v-if="scope.row.product.includeInsurance == 0">
                <el-button v-if="scope.row.parentId == null" type='text' @click="change(scope.row);dialogFormVisible = true">变更</el-button>
               <el-button style="margin-left:0px" v-else type='text' @click="change(scope.row,'变更记录');dialogFormVisible = true">变更记录</el-button>
               </span> -->
              </template>

              <!-- <el-button v-if="scope.row.validFrom != undefined&&">开发票</el-button>
						<el-button v-else type='text'>开发票</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="fenye" v-if="$route.query.type != 'type'">
      <div class="button">
        <el-button class="blue" type="text" @click="postCard"
          >导出全部卡号</el-button
        >
        <!-- <el-button class="blue" type="text">查看出单凭证</el-button> -->
      </div>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allpage">
      </el-pagination>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>请确认退单？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureExit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="友情提示"
      :visible.sync="centerDialogVisible1"
      width="30%"
      center
    >
      <refundDialog
        :fpdm="exitData.fpdm"
        :fphm="exitData.fphm"
        :prodectName="creatData.product.name"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible1 = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 变更 -->
    <el-dialog title="更改保障人" :visible.sync="dialogFormVisible">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名" prop="name">
          <el-input :disabled="disabled" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobileno">
          <el-input :disabled="disabled" v-model="ruleForm.mobileno"></el-input>
        </el-form-item>
        <el-form-item label="证件号" prop="nationalId">
          <el-input
            :disabled="disabled"
            v-model="ruleForm.nationalId"
          ></el-input>
        </el-form-item>
        <el-form-item label="保障生效时间" prop="validFrom">
          <el-col :span="12">
            <el-date-picker
              :disabled="disabled"
              v-model="ruleForm.validFrom"
              type="datetime"
              :picker-options="pickerOptions"
              value-format="timestamp"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
          <el-col :span="11">
            <el-date-picker
              :disabled="disabled"
              v-model="ruleForm.birthday"
              type="date"
              value-format="timestamp"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex" :disabled="disabled">
            <el-radio label="M">男</el-radio>
            <el-radio label="F">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          v-if="disabledif"
          type="primary"
          @click="submitForm('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 凭证下载入口 -->
    <el-dialog title="凭证下载" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column label="凭证类型" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.scOpType == 1">团单凭证</span>
            <span v-else-if="scope.row.scOpType == 2">团单凭证(批改)</span>
            <span v-else-if="scope.row.scOpType == 3">团单凭证(批减)</span>
          </template>
        </el-table-column>
        <el-table-column label="生成日期" width="200">
          <template slot-scope="scope">
            <span>{{ setTime(scope.row.createAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="see(scope.row.scUrl)"
              >查看</el-button
            >
            <!-- <el-button style="margin-left:0px"  type='text' @click="download(scope.row);">下载</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderbillDetail,
  listByDetail,
  refund,
  searchBill,
  getPCActivateSign,
  downloadPdf,
  salechangeBillInfo,
  orderDetail,
} from "@/axios/api.js";
import common from "@/assets/common.js";
import Clipboard from "clipboard";
import { Loading } from "element-ui";
import axios from "axios";
import refundDialog from "@/components/refundDialog";
export default {
  data() {
    return {
      dialogTableVisible: false,
      gridData: [],
      channeID: "",
      divisionDay: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      includeInsurance: "",
      dialogFormVisible: false,
      currentBillId: "",
      // 更改保障人
      ruleForm: {
        name: "",
        mobileno: "",
        nationalId: "",
        validFrom: "",
        birthday: "",
        sex: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        mobileno: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入11位手机号码", trigger: "blur" },
          {
            pattern:
              /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: "请输入正确的手机号码",
          },
        ],
        nationalId: [
          { required: true, message: "请输入证件号", trigger: "blur" },
          { min: 18, max: 18, message: "请输入正确证件号", trigger: "blur" },
        ],
        validFrom: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        birthday: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        desc: [{ required: true, message: "", trigger: "blur" }],
      },
      disabledif: true,
      disabled: false,
      searchText: "",
      tableData: [],
      tableData4: [],
      formInline: {
        text: "",
      },
      creatData: {
        bill: {},
        channel: {},
        product: {},
        saleUser: {},
      },
      billingState: [
        "创建",
        "线上支付完成",
        "挂帐月结-未付",
        "线下转账-已付款",
        "已退单",
        "投保失败-退单",
      ],
      centerDialogVisible: false,
      centerDialogVisible1: false,
      exitData: {},
      allpage: 0, //数据总数
      eachPage: 10, //每页
      indexPage: 0, //当前页
      timer: null,
      fuzhiData: "",
    };
  },
  components: {
    refundDialog,
  },

  methods: {
    see(url) {
      console.log(url);
      window.open(url);
    },
    go() {
      this.$router.go(-1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          var arr = this.ruleForm;
          console.log(arr);
          var obj = {
            currentBillId: this.currentBillId,
            billdetail: JSON.stringify(arr),
          };
          salechangeBillInfo(obj).then((res) => {
            if (res.data.code == "0") {
              this.dialogFormVisible = false;
              this.getData();
            }
            console.log(res);
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    change(item, type) {
      console.log(type);
      if (type == "变更记录") {
        this.ruleForm = item.detail.parentDetail;
        this.disabledif = false;
        this.disabled = true;
      } else {
        this.disabled = false;
        this.disabledif = true;
        this.currentBillId = item.detail.id;
        (this.ruleForm.name = item.detail.name),
          (this.ruleForm.mobileno = item.detail.mobileno),
          (this.ruleForm.nationalId = item.detail.nationalId),
          (this.ruleForm.validFrom = item.detail.validFrom),
          (this.ruleForm.birthday = item.detail.birthday),
          (this.ruleForm.sex = item.detail.sex);
      }
      console.log(item);
    },

    fuzhiFun(id) {
      return new Promise((resove, reject) => {
        getPCActivateSign({ detailId: id })
          .then((res) => {
            resove(
              SEVERSEWM +
                "equitycard/toPcActivate?detailId=" +
                id +
                "&sign=" +
                res.data.obj
            );
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setTime(str) {
      return common.time(str);
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.eachPage = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.indexPage = (val - 1) * this.eachPage;
      console.log(val);
      this.getData();
    },
    getData() {
      if (this.$route.query.type == "type") {
        orderbillDetail({ billDetailId: this.$route.query.id }).then((res) => {
          console.log(res);

          // this.divisionDay = res.data.obj.product.divisionDay
          this.creatData = res.data.obj;
          this.gridData = res.data.obj.scList;
          console.log(res.data.details);
          this.tableData = res.data.obj.details;
          this.allpage = res.data.obj.detailCount;
          var bTn = false;
          this.tableData.forEach((item, index) => {
            item.nowTime = new Date().getTime();
            item.copy = `${SEVERS}djxh5/#/introduceProduct?productId=${this.creatData.product.id}&code=${item.code}'&type=' + 1`;
            if (item.validFrom) {
              if (!item.serviceCredential) {
                bTn = true;
              }
            }
            console.log(this.creatData.product.productGroup);
            if (this.creatData.product.productGroup == "G74") {
              var a = item.resident.indexOf("_");
              item.resident = item.resident.substr(a + 1, item.resident.length);
              console.log(item.resident);
            }
          });
          if (bTn) {
            setTimeout(() => {
              this.getData();
            }, 2000);
          }
        });
      } else {
        var data = {
          billId: this.$route.query.id,
          start: this.indexPage,
          count: this.eachPage,
        };
        listByDetail(data)
          .then((res) => {
            // console.log(res)
            // console.log(res.data.obj.product.includeInsurance)
            // this.includeInsurance = res.data.obj.product.includeInsurance
            // console.log(this.includeInsurance)
            this.divisionDay = res.data.obj.product
              ? res.data.obj.product.divisionDay
              : null;
            this.creatData = res.data.obj;
            this.gridData = res.data.obj.scList;
            // console.log(res.data.obj2[0].product.periodType)
            // for(var i = 0; i<res.data.obj2.length; i++) {
            //    if(res.data.obj2[i].product.periodType == 1) {
            //      res.data.obj2[i].product.periodType = '年'
            //    }else if(res.data.obj2[i].product.periodType == 2){
            //      res.data.obj2[i].product.periodType = '月'
            //    }else {
            //      res.data.obj2[i].product.periodType = '日'
            //    }
            // }
            this.tableData = res.data.obj2;
            this.allpage = res.data.obj.detailCount;
            var bTn = false;
            this.tableData.forEach((item, index) => {
              item.parentDetail = [item.parentDetail];
              item.nowTime = new Date().getTime();
              item.copy = `${SEVERS}djxh5/#/introduceProduct?productId=${this.creatData.product.id}&code=${item.code}'&type=' + 1`;
              if (item.validFrom) {
                if (!item.serviceCredential) {
                  bTn = true;
                }
              }
              // console.log(this.creatData.product.productGroup )
              if (this.creatData.product.productGroup == "G74") {
                var a = item.resident.indexOf("_");
                item.resident = item.resident.substr(
                  a + 1,
                  item.resident.length
                );
                console.log(item.resident);
              }
            });
            // console.log(this.tableData)
            if (bTn) {
              setTimeout(() => {
                this.getData();
              }, 2000);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    sureExit() {
      var data = {
        // billId:this.$route.query.id,
        billDetailId: this.exitData.id,
      };
      refund(data)
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "退单成功！",
              type: "success",
            });
            if (this.exitData.fpdm) {
              this.centerDialogVisible1 = true;
            }
          } else if (res.data.code == 105009) {
            this.$message.error("保障卡已激活不能退款！");
          } else if (res.data.code == 105014) {
            this.$message.error("退单失败！");
          } else if (res.data.code == 105015) {
            this.$message.error("部分退单失败！");
          }
          this.getData();
          this.centerDialogVisible = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    seachBox() {
      this.getData();
    },
    postCard() {
      var token = JSON.parse(window.localStorage.getItem("token")).data.obj
        .token;
      window.location = `${SEVERS}/rescue_sale/order/export?id=${this.$route.query.id}&token=${token}`;
    },
    tdDownPdf() {
      this.dialogTableVisible = true;
    },
    downPdf() {
      var loadingInstance = Loading.service({ fullscreen: true });
      const httpAxios = axios.create(); //创建实例
      httpAxios.defaults.timeout = 1000 * 60 * 2;
      httpAxios
        .get(SEVERS + "1.0/rescue_sale/sale/download_pdf", {
          params: {
            token: JSON.parse(window.localStorage.getItem("token")).data.obj
              .token,
            id: this.$route.query.id,
          },
        })
        .then((res) => {
          console.log(res);

          if (res.data.code == 0) {
            loadingInstance.close();
            window.location = res.data.obj;
          }
        })
        .catch((err) => {
          console.log(err);
          loadingInstance.close();
        });
    },
  },
  mounted() {
    this.getData();
    this.channeID = localStorage.getItem("channelId");
    const clipboard = new Clipboard(".icon-copy");
    clipboard.on("success", (e) => {
      this.$message.success(e.text + " 已复制到剪贴板！");
    });
    clipboard.on("error", (e) => {
      console.log("该浏览器不支持自动复制");
      clipboard.destroy();
    });
  },
};
</script>
<style>
.has-gutter th {
  background-color: #f5f7fb;
}
</style>
<style scoped="scoped">
h3 {
  color: #333;
  font-weight: normal;
  margin-bottom: 20px;
  margin-top: 20px;
}

.searchBox {
  margin-top: 20px;
}
.searchBox ul {
  overflow: hidden;
  margin-left: 20px;
  margin-bottom: 20px;
}
.searchBox ul li {
  float: left;
  width: 30%;
  min-width: 300px;
  color: #666;
  margin-bottom: 10px;
}
.input {
  width: 400px;
}
.copeA {
  cursor: pointer;
  color: #666;
}
.zsh div {
  margin-bottom: 10px;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/orderDetails2.vue